import React from 'react';
import { IconButton } from '../core/IconButton.jsx';

function fmt(sec) {
  const m = Math.floor(sec / 60);
  const s = Math.round(sec % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}

/** Up-next list (播放列表). Current row shows an equalizer; rows are selectable/removable. */
export function QueuePanel({ items = [], currentId, playing = false, onSelect, onRemove, onClose, className = '', style }) {
  return (
    <div className={`bjl-queue ${className}`} style={style}>
      <div className="bjl-queue__head">
        <strong>播放列表</strong>
        <span className="bjl-queue__count">{items.length} 集</span>
        {onClose ? <IconButton icon="close" label="关闭" size="sm" onClick={onClose} /> : null}
      </div>
      {items.length === 0 ? (
        <div className="bjl-queue__empty">播放列表还是空的。去挑一集？</div>
      ) : (
        <div className="bjl-queue__list">
          {items.map((it, i) => {
            const current = it.id === currentId;
            return (
              <div key={it.id} role="button" tabIndex={0} className={`bjl-queue__row ${current ? 'is-current' : ''}`} onClick={() => onSelect && onSelect(it.id)}>
                {current ? (
                  <span className={`bjl-eq ${playing ? '' : 'is-paused'}`}><span></span><span></span><span></span></span>
                ) : (
                  <span className="bjl-queue__idx">{String(i + 1).padStart(2, '0')}</span>
                )}
                <span className="bjl-queue__name">{it.title}</span>
                <span className="bjl-queue__dur">{fmt(it.duration || 0)}</span>
                <span
                  className="bjl-queue__remove"
                  onClick={(e) => { e.stopPropagation(); onRemove && onRemove(it.id); }}
                >
                  <IconButton icon="close" label="移出列表" size="sm" />
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
